import i18n from '../i18n';

export function currentLocale() {
  return i18n.language === 'zh-TW' ? 'zh-TW' : 'en-US';
}

export function formatDate(dateString) {
  if (!dateString) return i18n.t('common.na');
  try {
    const d = new Date(dateString);
    return d.toLocaleDateString(currentLocale(), { year: 'numeric', month: 'long', day: 'numeric' });
  } catch (e) {
    return String(dateString);
  }
}

/** YYYY-MM-DD — same as <input type="date"> edit fields */
export function formatDateYMD(dateString) {
  if (!dateString) return i18n.t('common.na');
  try {
    const raw = String(dateString).trim();
    const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
    if (m) return m[1];
    const d = new Date(raw);
    if (Number.isNaN(d.getTime())) return raw;
    const y = d.getFullYear();
    const mo = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${mo}-${day}`;
  } catch (e) {
    return String(dateString);
  }
}

export function formatDateTime(dateString) {
  if (!dateString) return i18n.t('common.na');
  try {
    const d = new Date(dateString);
    return d.toLocaleString(currentLocale(), { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
  } catch (e) {
    return String(dateString);
  }
}

export function formatTime(dateString) {
  if (!dateString) return i18n.t('common.na');
  try {
    const d = new Date(dateString);
    return d.toLocaleTimeString(currentLocale(), { hour: '2-digit', minute: '2-digit' });
  } catch (e) {
    return String(dateString);
  }
}
